import { assignOrganizationStudents } from 'api/admin'

/**
 * Assign the current selection to a counsellor.
 * Uses the provided studentIds as-is (post-removal selection).
 */
export async function assignSelectedStudents({ counselorId, studentIds }) {
	const id = String(counselorId || '').trim()
	const ids = (studentIds || []).map(item => String(item || '').trim()).filter(Boolean)

	if (!id) {
		throw new Error('counselorId is required')
	}
	if (!ids.length) {
		throw new Error('studentIds is required')
	}

	return assignOrganizationStudents({
		counselorId: id,
		studentIds: ids,
	})
}
